<template>
  <div>
    <v-container fluid style="padding-bottom: 0px">
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar class="primary white--text">
            <router-link
              v-if="$route.params.customerId"
              :to="{
                name: 'BuyersInfo',
                params: { buyerId: $route.params.customerId },
              }"
            >
              <v-btn icon dark @click="dialog = false">
                <v-icon>keyboard_backspace</v-icon>
              </v-btn>
            </router-link>
            <v-toolbar-title class="text-xs-center">Payment</v-toolbar-title>
            <v-spacer></v-spacer>
            <h2 class="title white--text text--darken-4">
              {{ this.currentUser.name }}
            </h2>
            <v-spacer></v-spacer>
            <v-select
              class="select-firm"
              dense
              flat
              clearable
              item-text="name"
              return-object
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
            ></v-select>
            <v-spacer />
            <router-link
              v-if="$route.params.customerId"
              :to="{
                name: 'BuyersInfo',
                params: { buyerId: $route.params.customerId },
              }"
            >
              <v-btn icon dark @click="dialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </router-link>
          </v-toolbar>
          <!-- <v-radio-group v-model="payoffType">
            <v-radio :label="`Pay off Via invoices`" :value="true"></v-radio>
            <v-radio :label="`Pay off Normally`" :value="false"></v-radio>
          </v-radio-group> -->
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid grid-list-md fill-height>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-card flat>
            <!-- <v-card-title primary class="primary white--text">
                <h3 color="primary" style="text-align: center;">Input GST</h3>
            </v-card-title>-->
            <v-card-text>
              <!-- <div class="remaing-head">
                <v-layout row wrap>
                  <v-flex xs4 sm4 md4 style="padding-top : 14px;">
                    <h4>Remaining Balance</h4>
                  </v-flex>
                  <v-flex xs8 sm8 md8 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="totalRemainingAmount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div> -->
              <!-- <div class="remaing-head">
                <v-layout row wrap>
                  <v-flex xs3 sm3 md3 style="padding-top : 14px;">
                    <h4>Opening Amount Total</h4>
                  </v-flex>
                  <v-flex xs3 sm3 md3 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="openingBalance.amount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                    <v-flex xs3 sm3 md3 style="padding-top : 14px;">
                 
                    <h4>Opening Amount Selected</h4>
                  </v-flex>
                  <v-flex xs3 sm3 md3 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="openingBalance.selectedAmount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <h4>Id</h4>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <h4>Date</h4>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <h4>Amount</h4>
                  </v-flex>
                </v-layout>
              </div>
              <div>
                <v-layout
                  row
                  wrap
                  v-for="(op, index) in openingBalance.invoices"
                  :key="`op-${index}`"
                >
                  <v-flex xs4 sm4 md4 style="padding-top : 14px;">
                    <v-checkbox
                      @change="calculateFromChecked()"
                      style="margin:0px;font-size: 10px;"
                      class="mx-2"
                      v-model="op.checked"
                      :label="op['.key']"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs4 sm4 md4 style="padding-top : 14px;">
                    <h4>{{new Date(op.date).toLocaleDateString('en-GB')}}</h4>
                  </v-flex>
                  <v-flex xs4 sm4 md4 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      v-model="op.amount"
                      @keyup="calculateFromChecked()"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
              <div class="remaing-head">
                <v-layout row wrap>
                  <v-flex xs3 sm3 md3 style="padding-top : 14px;">
                     <h4>Due Amount Total</h4>
                  </v-flex>
                  <v-flex xs3 sm3 md3 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="dueAmount.amount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                   <v-flex xs3 sm3 md3 style="padding-top : 14px;">
                     <h4>Due Amount Selected</h4>
                  </v-flex>
                  <v-flex xs3 sm3 md3 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="dueAmount.selectedAmount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                     <v-flex xs3 sm3 md3 style="padding-top : 14px;">
                     <h4>Discount Amount Total</h4>
                  </v-flex>
                  <v-flex xs3 sm3 md3 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="dueAmount.discountAmount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                   <v-flex xs3 sm3 md3 style="padding-top : 14px;">
                     <h4>Discount Amount Selected</h4>
                  </v-flex>
                  <v-flex xs3 sm3 md3 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="dueAmount.selectedDiscountAmount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <h4>Invoice Id</h4>
                  </v-flex>
                  <v-flex xs2 sm2 md2>
                    <h4>Date</h4>
                  </v-flex>
                  <v-flex xs3 sm3 md3>
                    <h4>Remaming Amount</h4>
                  </v-flex>
                    <v-flex xs3 sm3 md3>
                    <h4>Discount Amount</h4>
                  </v-flex>
                </v-layout>
              </div>
              <div>
                <v-layout
                  row
                  wrap
                  v-for="(invoice, index) in dueAmount.invoices"
                  :key="`invoice-${index}`"
                >
                  <v-flex xs4 sm4 md4 style="padding-top : 14px;">
                     <v-checkbox
                     @change="calculateFromChecked()"
                      style="margin:0px;font-size: 10px;"
                      class="mx-2"
                      v-model="invoice.checked"
                      :label="invoice['invoiceId'] +' '+ (invoice['.key'])"
                    ></v-checkbox>
                    <h4></h4>
                  </v-flex>
                  <v-flex xs2 sm2 md2 style="padding-top : 14px;">
                    <h4>{{new Date(invoice.date).toLocaleDateString('en-GB')}}</h4>
                  </v-flex>
                  <v-flex xs3 sm3 md3 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="invoice.remainingAmount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                   <v-flex xs3 sm3 md3 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      v-model="invoice.discountAmount"
                      @keyup="calculateFromChecked()"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
              <div class="remaing-head">
                <v-layout row wrap>
                  <v-flex xs3 sm3 md3 style="padding-top : 14px;">
                    <h4>Advance Deposit</h4>
                  </v-flex>
                  <v-flex xs3 sm3 md3 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="advanceDeposit.amount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                   <v-flex xs3 sm3 md3 style="padding-top : 14px;">
                    <h4>Advance Deposit Total</h4>
                  </v-flex>
                  <v-flex xs3 sm3 md3 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="advanceDeposit.selectedAmount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <h4>Id</h4>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <h4>Date</h4>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <h4>Amount</h4>
                  </v-flex>
                </v-layout>
              </div>
              <div>
                <v-layout
                  row
                  wrap
                  v-for="(adDepo, index) in advanceDeposit.invoices"
                  :key="`adDepo-${index}`"
                >
                  <v-flex xs4 sm4 md4 style="padding-top : 14px;">
                      <v-checkbox
                      @change="calculateFromChecked()"
                      style="margin:0px;font-size: 10px;"
                      class="mx-2"
                      v-model="adDepo.checked"
                      :label="adDepo['.key']"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs4 sm4 md4 style="padding-top : 14px;">
                    <h4>{{new Date(adDepo.date).toLocaleDateString('en-GB')}}</h4>
                  </v-flex>
                  <v-flex xs4 sm4 md4 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      v-model="adDepo.amount"
                      @keyup="calculateFromChecked()"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
              <div class="remaing-head">
                <v-layout row wrap>
                  <v-flex xs3 sm3 md3 style="padding-top : 14px;">
                     <h4>Security Deposit Total</h4>
                  </v-flex>
                  <v-flex xs3 sm3 md3 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="securityDeposit.amount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                   <v-flex xs3 sm3 md3 style="padding-top : 14px;">
                     <h4>Security Deposit Selected</h4>
                  </v-flex>
                  <v-flex xs3 sm3 md3 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="securityDeposit.selectedAmount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <h4>Id</h4>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <h4>Date</h4>
                  </v-flex>
                  <v-flex xs4 sm4 md4>
                    <h4>Amount</h4>
                  </v-flex>
                </v-layout>
              </div>
              <div>
                <v-layout
                  row
                  wrap
                  v-for="(sec, index) in securityDeposit.invoices"
                  :key="`sec-${index}`"
                >
                  <v-flex xs4 sm4 md4 style="padding-top : 14px;">
                      <v-checkbox
                      @change="calculateFromChecked()"
                      style="margin:0px;font-size: 10px;"
                      class="mx-2"
                      v-model="sec.checked"
                      :label="sec['.key']"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs4 sm4 md4 style="padding-top : 14px;">
                    <h4>{{new Date(sec.date).toLocaleDateString('en-GB')}}</h4>
                  </v-flex>
                  <v-flex xs4 sm4 md4 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      v-model="sec.amount"
                      @keyup="calculateFromChecked()"
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div> -->
              <!-- <div class="remaing-head">
                <v-layout row wrap>
                  <v-flex xs4 sm4 md4 style="padding-top : 14px;">
                    <h4>Payoff Amount</h4>
                  </v-flex>
                  <v-flex xs8 sm8 md8 style="display:inline-flex;">
                    <v-text-field
                      style="padding: 0 4px 0 4px;"
                      :value="payoffAmount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div> -->
              <table class="fl-table">
                <thead>
                  <tr>
                    <th>Expand</th>
                    <th>Category Amount</th>
                    <th>Date</th>
                    <th>Firm</th>
                    <th>Invoice Id</th>
                    <th>Remaining Amount</th>
                    <th>Amount Selected</th>
                    <th>Discount Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <v-icon
                        v-if="!openingBalance.expand"
                        @click="toggle(openingBalance)"
                        color="primary"
                        >expand_more</v-icon
                      >
                      <v-icon
                        v-if="openingBalance.expand"
                        @click="toggle(openingBalance)"
                        color="primary"
                        >expand_less</v-icon
                      >
                    </td>
                    <td>
                      <h2>OPENING BALANCE</h2>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <v-text-field
                        style="padding: 0 4px 0 4px"
                        :value="openingBalance.amount"
                        readonly
                        type="number"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        style="padding: 0 4px 0 4px"
                        :value="openingBalance.selectedAmount"
                        readonly
                        type="number"
                      ></v-text-field>
                    </td>
                    <td></td>
                  </tr>
                  <template v-if="openingBalance.expand">
                    <tr
                      v-for="(op, index) in openingBalance.invoices"
                      :key="`op-${index}`"
                    >
                      <td></td>
                      <td></td>
                      <td>
                        {{ new Date(op.date).toLocaleDateString("en-GB") }}
                      </td>
                      <td>{{ getFirmName(op.firm) }}</td>
                      <td>
                        <v-checkbox
                          @change="calculateFromChecked()"
                          style="margin: 0px; font-size: 10px"
                          class="mx-2"
                          v-model="op.checked"
                          :label="op['.key']"
                        ></v-checkbox>
                      </td>
                      <td>
                        <v-text-field
                          style="padding: 0 4px 0 4px"
                          v-model="op.amount"
                          @keyup="calculateFromChecked()"
                          type="number"
                        ></v-text-field>
                        <b
                          class="red--text font-weight-bold"
                          v-if="
                            Number.parseFloat(op.amount) >
                            Number.parseFloat(op.staticAmount)
                          "
                          >Should be equal or less then {{ op.staticAmount }}</b
                        >
                        <b v-else> of {{ op.staticAmount }}</b>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </template>
                  <tr>
                    <td>
                      <v-icon
                        v-if="!dueAmount.expand"
                        @click="toggle(dueAmount)"
                        color="primary"
                        >expand_more</v-icon
                      >
                      <v-icon
                        v-if="dueAmount.expand"
                        @click="toggle(dueAmount)"
                        color="primary"
                        >expand_less</v-icon
                      >
                    </td>
                    <td>
                      <h2>DUE INVOICES</h2>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <v-text-field
                        style="padding: 0 4px 0 4px"
                        :value="dueAmount.amount"
                        readonly
                        type="number"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        style="padding: 0 4px 0 4px"
                        :value="dueAmount.selectedAmount"
                        readonly
                        type="number"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        style="padding: 0 4px 0 4px"
                        :value="dueAmount.discountAmount"
                        readonly
                        type="number"
                      ></v-text-field>
                    </td>
                  </tr>
                  <template v-if="dueAmount.expand">
                    <tr
                      v-for="(invoice, index) in dueAmount.invoices"
                      :key="`invoice-${index}`"
                    >
                      <td></td>
                      <td></td>
                      <td>
                        {{ new Date(invoice.date).toLocaleDateString("en-GB") }}
                      </td>
                      <td>{{ getFirmName(invoice.firm) }}</td>
                      <td>
                        <v-checkbox
                          @change="calculateFromChecked()"
                          style="margin: 0px; font-size: 10px"
                          class="mx-2"
                          v-model="invoice.checked"
                          :label="invoice['invoiceId'] + ' '"
                        ></v-checkbox>
                      </td>
                      <td>
                        <span style="display: flex">
                          <v-text-field
                            style="padding: 0 4px 0 4px"
                            :value="invoice.remainingAmount"
                            readonly
                            class="error--text font-weight-light"
                            color="red lighten-1"
                            type="number"
                          ></v-text-field>
                          <h2 class="primary--text font-weight-bold align-start" style="text-align: left;">[ {{ invoice.totalAmount }} &nbsp; </h2> <h2> - </h2>  &nbsp;<h2 class="success--text font-weight-bold align-end" style="text-align: right;">{{ invoice.paidAmount }} ]</h2>
                        </span>
                        <!-- <v-text-field
                          style="padding: 0 4px 0 4px"
                          :value="invoice.totalAmount"
                          readonly
                          type="number"
                        ></v-text-field>
                        <v-text-field
                          style="padding: 0 4px 0 4px"
                          :value="invoice.paidAmount"
                          readonly
                          type="number"
                        ></v-text-field> -->
                      </td>
                      <td></td>
                      <td>
                        <v-text-field
                          style="padding: 0 4px 0 4px"
                          v-model="invoice.discountAmount"
                          @keyup="calculateFromChecked()"
                          type="number"
                        ></v-text-field>
                      </td>
                    </tr>
                  </template>

                  <tr>
                    <td>
                      <v-icon
                        v-if="!advanceDeposit.expand"
                        @click="toggle(advanceDeposit)"
                        color="primary"
                        >expand_more</v-icon
                      >
                      <v-icon
                        v-if="advanceDeposit.expand"
                        @click="toggle(advanceDeposit)"
                        color="primary"
                        >expand_less</v-icon
                      >
                    </td>
                    <td>
                      <h2>ADVANCE DEPOSIT</h2>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <v-text-field
                        style="padding: 0 4px 0 4px"
                        :value="advanceDeposit.amount"
                        readonly
                        type="number"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        style="padding: 0 4px 0 4px"
                        :value="advanceDeposit.selectedAmount"
                        readonly
                        type="number"
                      ></v-text-field>
                    </td>
                    <td></td>
                  </tr>
                  <template v-if="advanceDeposit.expand">
                    <tr
                      v-for="(adDepo, index) in advanceDeposit.invoices"
                      :key="`adDepo-${index}`"
                    >
                      <td></td>
                      <td></td>
                      <td>
                        {{ new Date(adDepo.date).toLocaleDateString("en-GB") }}
                      </td>
                      <td>{{ getFirmName(adDepo.firm) }}</td>
                      <td>
                        <v-checkbox
                          @change="calculateFromChecked()"
                          style="margin: 0px; font-size: 10px"
                          class="mx-2"
                          v-model="adDepo.checked"
                          :label="adDepo['.key']"
                        ></v-checkbox>
                      </td>
                      <td>
                        <v-text-field
                          style="padding: 0 4px 0 4px"
                          v-model="adDepo.amount"
                          @keyup="calculateFromChecked()"
                          type="number"
                        ></v-text-field>
                        <b
                          class="red--text font-weight-bold"
                          v-if="
                            Number.parseFloat(adDepo.amount) >
                            Number.parseFloat(adDepo.staticAmount)
                          "
                          >Should be equal or less then
                          {{ adDepo.staticAmount }}</b
                        >
                        <b v-else> of {{ adDepo.staticAmount }}</b>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </template>
                  <tr>
                    <td>
                      <v-icon
                        v-if="!securityDeposit.expand"
                        @click="toggle(securityDeposit)"
                        color="primary"
                        >expand_more</v-icon
                      >
                      <v-icon
                        v-if="securityDeposit.expand"
                        @click="toggle(securityDeposit)"
                        color="primary"
                        >expand_less</v-icon
                      >
                    </td>
                    <td>
                      <h2>SECURITY DEPOSIT</h2>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <v-text-field
                        style="padding: 0 4px 0 4px"
                        :value="securityDeposit.amount"
                        readonly
                        type="number"
                      ></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        style="padding: 0 4px 0 4px"
                        :value="securityDeposit.selectedAmount"
                        readonly
                        type="number"
                      ></v-text-field>
                    </td>
                    <td></td>
                  </tr>
                  <template v-if="securityDeposit.expand">
                    <tr
                      v-for="(sec, index) in securityDeposit.invoices"
                      :key="`sec-${index}`"
                    >
                      <td></td>
                      <td></td>
                      <td>
                        {{ new Date(sec.date).toLocaleDateString("en-GB") }}
                      </td>
                      <td>{{ getFirmName(sec.firm) }}</td>
                      <td>
                        <v-checkbox
                          @change="calculateFromChecked()"
                          style="margin: 0px; font-size: 10px"
                          class="mx-2"
                          v-model="sec.checked"
                          :label="sec['.key']"
                        ></v-checkbox>
                      </td>
                      <td>
                        <v-text-field
                          style="padding: 0 4px 0 4px"
                          v-model="sec.amount"
                          @keyup="calculateFromChecked()"
                          type="number"
                        ></v-text-field>
                        <b
                          class="red--text font-weight-bold"
                          v-if="
                            Number.parseFloat(sec.amount) >
                            Number.parseFloat(sec.staticAmount)
                          "
                          >Should be equal or less then
                          {{ sec.staticAmount }}</b
                        >
                        <b v-else> of {{ sec.staticAmount }}</b>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 s12 md12>
          <v-card flat>
            <v-card-text>
              <div>
                <v-layout row wrap>
                  <v-flex xs2 sm2 md2 style="padding-top: 14px">
                    <h4>Remaining Balance</h4>
                  </v-flex>
                  <v-flex xs2 sm2 md2 style="display: inline-flex">
                    <v-text-field
                      style="padding: 0 4px 0 4px"
                      :value="totalRemainingAmount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>
              <div>
                <v-layout row wrap>
                  <v-flex xs2 sm2 md2 style="padding-top: 14px">
                    <h4>Payoff Amount</h4>
                  </v-flex>
                  <v-flex xs2 sm2 md2 style="display: inline-flex">
                    <v-text-field
                      style="padding: 0 4px 0 4px"
                      :value="payoffAmount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>

              <div>
                <v-layout row wrap>
                  <v-flex xs2 sm2 md2 style="padding-top: 14px">
                    <h4>Remaining Amount</h4>
                  </v-flex>
                  <v-flex xs2 sm2 md2 style="display: inline-flex">
                    <v-text-field
                      style="padding: 0 4px 0 4px"
                      :value="remainingAmount"
                      readonly
                      type="number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <h4>
                  <b class="red--text font-weight-bold" v-if="insufficientError"
                    >Insufficient amount.</b
                  >
                </h4>

                <v-layout row wrap v-if="selectedFirm">
                  <v-flex xs2 sm2 md2 style="padding-top: 14px">
                    <v-menu
                      :close-on-content-click="false"
                      v-model="datepicker"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="selectedDate"
                        label="Date"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="selectedDate"
                        @input="datepicker = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2 sm2 md2 style="padding-top: 14px">
                    <v-select
                      dense
                      :items="[
                        {
                          text: 'Cash',
                          value: 'Cash',
                        },
                        {
                          text: 'Bank Account',
                          value: 'Bank Account',
                        },
                        {
                          text: 'Cash & Bank Account',
                          value: 'CashAndBank Account',
                        },
                      ]"
                      label="Select Payment Type"
                      v-model="paymentType"
                    ></v-select>
                  </v-flex>
                  <v-flex xs2 sm2 md2 style="padding-top: 14px">
                    <v-text-field
                      v-model="amountFromCash"
                      type="number"
                      label="Amount from Cash"
                      v-if="
                        ['Cash', 'CashAndBank Account'].includes(paymentType)
                      "
                    ></v-text-field>
                    <b
                      class="text-error"
                      v-if="
                        ['Cash', 'CashAndBank Account'].includes(paymentType) &&
                        !(
                          Number.parseFloat(amountFromBank) +
                            Number.parseFloat(amountFromCash) ==
                          Number.parseFloat(payoffAmount)
                        )
                      "
                      >Total should be equal to Payoff amount</b
                    >
                  </v-flex>
                  <v-flex xs2 sm2 md2 style="padding-top: 14px">
                    <v-text-field
                      v-model="amountFromBank"
                      v-if="
                        ['Bank Account', 'CashAndBank Account'].includes(
                          paymentType
                        )
                      "
                      type="number"
                      label="Amount from Bank"
                    ></v-text-field>
                    <b
                      class="text-error"
                      v-if="
                        ['Bank Account', 'CashAndBank Account'].includes(
                          paymentType
                        ) &&
                        !(
                          Number.parseFloat(amountFromBank) +
                            Number.parseFloat(amountFromCash) ==
                          Number.parseFloat(payoffAmount)
                        )
                      "
                      >Total should be equal to Payoff amount</b
                    >
                  </v-flex>
                  <v-flex xs2 sm2 md2 style="padding-top: 14px">
                    <v-select
                      dense
                      :items="banksByFirms"
                      v-if="
                        ['Bank Account', 'CashAndBank Account'].includes(
                          paymentType
                        )
                      "
                      label="Select Bank"
                      v-model="selectedBank"
                      flat
                      clearable
                      item-text="bankName"
                      return-object
                      :disabled="paymentType == 'Cash' || paymentType == ''"
                    ></v-select>
                  </v-flex>
                  <v-flex xs2 sm2 md2 style="padding-top: 14px">
                    <v-select
                      dense
                      :disabled="paymentType == 'Cash' || paymentType == ''"
                      v-if="
                        ['Bank Account', 'CashAndBank Account'].includes(
                          paymentType
                        )
                      "
                      :items="[
                        {
                          text: 'Cheque',
                          value: 'Cheque',
                        },
                        {
                          text: 'NEFT',
                          value: 'NEFT',
                        },
                        {
                          text: 'RTGS',
                          value: 'RTGS',
                        },
                        {
                          text: 'IMPS',
                          value: 'IMPS',
                        },
                      ]"
                      label="Select Transfer type"
                      v-model="transferType"
                      @input="transferTypeDialog = true"
                    ></v-select>
                  </v-flex>
                  <v-flex xs2 sm2 md2 style="padding-top: 14px">
                    <v-btn
                      :disabled="
                        ispayDisable ||
                        !(
                          Number.parseFloat(amountFromBank) +
                            Number.parseFloat(amountFromCash) ==
                          Number.parseFloat(payoffAmount)
                        )
                      "
                      class="primary white--text"
                      @click.native="payAmount()"
                      >Pay Amount</v-btn
                    >
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog v-model="transferTypeDialog" max-width="500px">
        <v-card>
          <v-card-title class="primary white--text">
            <span class="headline">
              Transfer Information
              <b>{{ transferType }}</b>
            </span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    type="number"
                    v-model="transferDetails.accountNumber"
                    label="A/C Number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    type="text"
                    v-model="transferDetails.accountHolderName"
                    label="A/C Holder Name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    type="text"
                    v-model="transferDetails.bankName"
                    label="Bank Name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    type="text"
                    v-model="transferDetails.IFSCcode"
                    label="IFSC Code"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    type="text"
                    v-model="transferDetails.remark"
                    label="Remark"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="transferTypeDialog = false">Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
export default {
  data() {
    return {
      payoffType: Boolean,
      selectedFirm: null,
      remainingAmount: 0,
      paymentType: "",
      selectedBank: null,
      payoffAmount: 0,
      ispayDisable: false,
      transferType: 0,
      amountFromCash: 0,
      amountFromBank: 0,
      insufficientError: 0,
      transferTypeDialog: false,
      totalRemainingAmount: 0,
      isBuyer: null,
      datepicker: false,
      selectedDate: new Date().toISOString().substr(0, 10),
      currentUser: null,
      dueAmount: {
        checked: false,
        amount: 0,
        selectedAmount: 0,
        selectedDiscountAmount: 0,
        discountAmount: 0,
        invoices: [],
        expand: true,
      },
      advanceDeposit: {
        checked: false,
        amount: 0,
        selectedAmount: 0,
        invoices: [],
        expand: true,
      },
      securityDeposit: {
        checked: false,
        amount: 0,
        selectedAmount: 0,
        invoices: [],
        expand: true,
      },
      openingBalance: {
        checked: false,
        amount: 0,
        selectedAmount: 0,
        invoices: [],
        expand: true,
      },
      transferDetails: {
        accountNumber: "",
        accountHolderName: "",
        bankName: "",
        IFSCcode: "",
        remark: "",
      },
    };
  },
  mounted() {
    this.getCurrentUserDetails();
  },
  created() {
    this.$bindAsArray(
      "customerDeposit",
      this.$root.$firebaseRefs.customerDeposit
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.$bindAsArray(
        "banks",
        this.$root.$firebaseRefs.account
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "buyerById",
        this.$root.$firebaseRefs.buyer
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "sellerById",
        this.$root.$firebaseRefs.seller
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsObject(
        "firmById",
        this.$root.$firebaseRefs.firm
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsArray(
        "firms",
        this.$root.$firebaseRefs.firm
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      ),
      this.$bindAsArray(
        "invoice",
        this.$root.$firebaseRefs.invoice
          .orderByChild("brand")
          .equalTo(this.selectedBrand)
      );
    this.getData();
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
    firmsByBrand1() {
      return this.firms.filter((item) => item["brand"] === this.selectedBrand);
    },
    // current brands firm list
    firmsByBrand() {
      // return selected brand firms
      let firmsB = this.firms.filter(
        (item) => item["brand"] === this.selectedBrand
      );
      firmsB.map((item) => {
        if (item.defaultFirm) {
          this.selectedFirm = item;
        }
      });
      return firmsB;
    },
    banksByFirms() {
      return this.banks.filter((item) => {
        return (
          item["brand"] === this.selectedBrand &&
          item["firm"] === this.selectedFirm[".key"]
        );
      });
    },
  },
  methods: {
    toggle(item) {
      item.expand = !item.expand;
    },
    getFirmName(firmId) {
      if (firmId && this.firms) {
        return this.firms.filter((item) => item[".key"] === firmId)[0]["name"];
      }
      return "--";
    },
    getData() {
      this.buyerInvoices();
      this.advanceDepositListByCustomer();
      this.openingBalanceListByCustomer();
      this.securityDepositListByCustomer();
      this.calculateFromChecked();
    },
    payAmount() {
      this.getCurrentUserDetails();
      let settledInvoiceDetails = [];
      this.dueAmount.invoices.map((invoice, index) => {
        let pendingAmount = invoice.paidAmount ? (parseFloat(invoice.totalAmount) - parseFloat(invoice.paidAmount)) : parseFloat(invoice.totalAmount);
        pendingAmount = parseFloat(pendingAmount)
        if (invoice.checked) {
          this.dueAmount.invoices[index]["closedDate"] = new Date(
            this.selectedDate
          ).getTime();
          this.dueAmount.invoices[index]["status"] = "paid";
          // this.dueAmount.invoices[index]['paidAmount'] = invoice.paidAmount;
          if (this.paymentType == "Cash") {
            this.dueAmount.invoices[index]["amountFromCash"] =
              pendingAmount;
          } else if (this.paymentType == "Bank Account") {
            this.dueAmount.invoices[index]["amountFromBank"] =
              pendingAmount;
            this.dueAmount.invoices[index]["bank"] = this.selectedBank[".key"];
            this.dueAmount.invoices[index]["transferType"] = this.transferType;
            this.dueAmount.invoices[index]["transferDetails"] =
              this.transferDetails;
          } else {
            this.dueAmount.invoices[index]["amountFromCash"] =
              Number.parseFloat(pendingAmount) / 2;
            this.dueAmount.invoices[index]["amountFromBank"] =
              Number.parseFloat(pendingAmount) / 2;
            this.dueAmount.invoices[index]["bank"] = this.selectedBank[".key"];
            this.dueAmount.invoices[index]["transferType"] = this.transferType;
            this.dueAmount.invoices[index]["transferDetails"] =
              this.transferDetails;
          }
          // this.dueAmount.invoices[index]['amountFromBank'] = invoice.totalAmount;
          this.dueAmount.invoices[index]["transactionType"] = "Credit";
          this.dueAmount.invoices[index]["paymentType"] = this.paymentType;
          this.dueAmount.invoices[index]["remainingAmount"] = 0;
          // this.dueAmount.invoices[index]['date'] = new Date(this.selectedDate).getTime();

          let amountToBePaid =
            Number.parseFloat(this.dueAmount.invoices[index].amountFromCash) +
            Number.parseFloat(this.dueAmount.invoices[index].amountFromBank);
          settledInvoiceDetails.push({
            invoiceId: this.dueAmount.invoices[index][".key"],
            settledAmount: amountToBePaid,
            status: this.dueAmount.invoices[index].status,
          });
          this.updateInvoice(this.dueAmount.invoices[index]);
        }
      });
      if (settledInvoiceDetails.length) {
        let firm = this.firms.find(
          (item) => item[".key"] == this.selectedFirm[".key"]
        );
        let firmReceiptCount = this.isBuyer
          ? firm.lastReceiptCount
            ? Number.parseInt(firm.lastReceiptCount) + 1
            : 1
          : firm.lastReceiptCountSeller
          ? Number.parseInt(firm.lastReceiptCountSeller) + 1
          : 1;
        let amountToBePaid =
          Number.parseFloat(this.amountFromCash) +
          Number.parseFloat(this.amountFromBank);
        let receipt = {
          date: new Date(this.selectedDate).getTime(),
          firm: this.selectedFirm[".key"],
          isBuyer: this.isBuyer,
          buyerId: this.$route.params.customerId,
          brand: this.selectedBrand,
          amount: amountToBePaid,
          remainingAmount: 0,
          paymentType: this.paymentType,
          receiptNumber: firmReceiptCount,
          settledInvoiceDetails: settledInvoiceDetails,
        };

        if (this.paymentType == "Bank") {
          receipt["transferType"] = this.transferType;
          receipt["transferDetails"] = this.transferDetails;
        }
        // console.log(receipt);
        this.$root.$firebaseRefs.customerPayments.push(receipt);
        if (this.isBuyer) {
          this.$root.$firebaseRefs.firm.child(receipt.firm).update(
            {
              lastReceiptCount: Number.parseInt(receipt.receiptNumber),
            },
            () => {
              //console.info("last receiptNumber updated...");
            }
          );
        } else {
          this.$root.$firebaseRefs.firm.child(receipt.firm).update(
            {
              lastReceiptCountSeller: Number.parseInt(receipt.receiptNumber),
            },
            () => {
              //console.info("last receiptNumber updated...");
            }
          );
        };
      }
      this.managePayments();
      this.settleDeposites();
      // this.addRemainingBalance();
    },
    // addRemainingBalance(){
    //   let advanceDeposit = this.customerDeposit.filter(
    //     item =>
    //       item["brand"] === this.selectedBrand &&
    //       item["buyerId"] === this.$route.params.customerId &&
    //       item["type"] === "Advance" &&
    //       !!item["isUserCreated"] &&
    //       (parseInt(item["remainingAmount"]) > 0)
    //   );
    //   let advanceDepositTotal = 0;
    //   advanceDeposit.map((inv,index)  => {
    //     advanceDepositTotal += Number.parseFloat(inv.remainingAmount);
    //   });
    //   let openingBalance = this.customerDeposit.filter(
    //     item =>
    //       item["brand"] === this.selectedBrand &&
    //       item["buyerId"] === this.$route.params.customerId &&
    //       item["type"] === "Opening Balance" &&
    //        !!item["isUserCreated"] &&
    //       (parseInt(item["remainingAmount"]) > 0)
    //   );
    //   let openingBalanceTotal = 0;
    //   openingBalance.map((inv,index) => {
    //     openingBalanceTotal += Number.parseFloat(inv.remainingAmount);
    //   });
    //   let securityDeposit = this.customerDeposit.filter(
    //     item =>
    //       item["brand"] === this.selectedBrand &&
    //       item["buyerId"] === this.$route.params.customerId &&
    //       item["type"] === "Security" &&
    //        !!item["isUserCreated"] &&
    //       (parseInt(item["remainingAmount"]) > 0)
    //   );
    //   let securityDepositTotal = 0;
    //   securityDeposit.map((inv,index) => {
    //     securityDepositTotal += Number.parseFloat(inv.remainingAmount);
    //   });
    //   let totalAmount = ((Number.parseFloat(openingBalanceTotal)) - (Number.parseFloat(advanceDepositTotal) + Number.parseFloat(securityDepositTotal)))
    //   if(this.isBuyer) {
    //     let buyer = this.buyerById[this.$route.params.customerId];
    //     if(buyer) {
    //       buyer.remainingAmountFromDeposite = totalAmount
    //       delete buyer['.key']
    //       this.$root.$firebaseRefs.buyer.child(this.$route.params.customerId).set(buyer);
    //     }
    //   } else {
    //     let seller = this.sellerById[this.$route.params.customerId];
    //     if(seller) {
    //       seller.remainingAmountFromDeposite = totalAmount
    //       delete seller['.key']
    //       this.$root.$firebaseRefs.seller.child(this.$route.params.customerId).set(seller);
    //     }
    //   }
    // },
    getFirmName(firm) {
      return firm ? this.firmById[firm].name : "";
    },
    calculateFromChecked() {
      this.dueAmount.selectedAmount = 0;
      this.dueAmount.selectedDiscountAmount = 0;
      this.ispayDisable = false;
      this.dueAmount.invoices.map((inv) => {
        if (inv.checked) {
          this.dueAmount.selectedAmount += Number.parseFloat(
            inv["remainingAmount"]
          );
          this.dueAmount.selectedDiscountAmount += Number.parseFloat(
            inv["discountAmount"]
          );
        }
      });
      this.openingBalance.selectedAmount = 0;
      this.openingBalance.invoices.map((inv) => {
        if (inv.checked) {
          this.openingBalance.selectedAmount += Number.parseFloat(
            inv["amount"]
          );
          if (
            Number.parseFloat(inv.amount) > Number.parseFloat(inv.staticAmount)
          ) {
            this.ispayDisable = true;
          }
        }
      });

      this.securityDeposit.selectedAmount = 0;
      this.securityDeposit.invoices.map((inv) => {
        if (inv.checked) {
          this.securityDeposit.selectedAmount += Number.parseFloat(
            inv["amount"]
          );
          if (
            Number.parseFloat(inv.amount) > Number.parseFloat(inv.staticAmount)
          ) {
            this.ispayDisable = true;
          }
        }
      });

      this.advanceDeposit.selectedAmount = 0;
      this.advanceDeposit.invoices.map((inv) => {
        if (inv.checked) {
          this.advanceDeposit.selectedAmount += Number.parseFloat(
            inv["amount"]
          );
          if (
            Number.parseFloat(inv.amount) > Number.parseFloat(inv.staticAmount)
          ) {
            this.ispayDisable = true;
          }
        }
      });

      this.payoffAmount =
        Number.parseFloat(this.openingBalance.selectedAmount) +
        Number.parseFloat(this.dueAmount.selectedAmount) -
        (Number.parseFloat(this.advanceDeposit.selectedAmount) +
          Number.parseFloat(this.securityDeposit.selectedAmount) +
          Number.parseFloat(this.dueAmount.selectedDiscountAmount));
      this.totalRemainingAmount =
        Number.parseFloat(this.openingBalance.amount) +
        Number.parseFloat(this.dueAmount.amount) -
        (Number.parseFloat(this.advanceDeposit.amount) +
          Number.parseFloat(this.securityDeposit.amount) +
          Number.parseFloat(this.dueAmount.discountAmount));
      this.remainingAmount =
        Number.parseFloat(this.totalRemainingAmount) -
        Number.parseFloat(this.payoffAmount);
    },
    buyerInvoices() {
      this.dueAmount.invoices = this.invoice.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item.deleted != true &&
          item["buyerId"] === this.$route.params.customerId &&
          (item["status"] === "due" || item["status"] === "partial") &&
          (this.selectedFirm
            ? item["firm"] === this.selectedFirm[".key"]
            : true)
      );
      this.dueAmount.amount = 0;
      this.dueAmount.discountAmount = 0;
      this.dueAmount.invoices.map((inv, index) => {
        this.dueAmount.invoices[index]["checked"] = false;
        this.dueAmount.amount += Number.parseFloat(inv.remainingAmount);
        this.dueAmount.discountAmount += Number.parseFloat(inv.discountAmount);
      });
    },
    advanceDepositListByCustomer() {
      this.advanceDeposit.invoices = this.customerDeposit.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.$route.params.customerId &&
          item["type"] === "Advance" &&
          !!item["isUserCreated"] &&
          parseInt(item["remainingAmount"]) > 0 &&
          (this.selectedFirm
            ? item["firm"] === this.selectedFirm[".key"]
            : true)
      );
      this.advanceDeposit.amount = 0;
      this.advanceDeposit.invoices.map((inv, index) => {
        this.advanceDeposit.amount += Number.parseFloat(inv.amount);
        this.advanceDeposit.invoices[index]["checked"] = false;
        this.advanceDeposit.invoices[index]["amount"] = inv.remainingAmount;
        this.advanceDeposit.invoices[index]["staticAmount"] =
          inv.remainingAmount;
      });
    },
    openingBalanceListByCustomer() {
      this.openingBalance.invoices = this.customerDeposit.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.$route.params.customerId &&
          item["type"] === "Opening Balance" &&
          !!item["isUserCreated"] &&
          parseInt(item["remainingAmount"]) > 0 &&
          (this.selectedFirm
            ? item["firm"] === this.selectedFirm[".key"]
            : true)
      );
      this.openingBalance.amount = 0;
      this.openingBalance.invoices.map((inv, index) => {
        this.openingBalance.amount += Number.parseFloat(inv.amount);
        this.openingBalance.invoices[index]["checked"] = false;
        this.openingBalance.invoices[index]["amount"] = inv.remainingAmount;
        this.openingBalance.invoices[index]["staticAmount"] =
          inv.remainingAmount;
      });
    },
    securityDepositListByCustomer() {
      this.securityDeposit.invoices = this.customerDeposit.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.$route.params.customerId &&
          item["type"] === "Security" &&
          !!item["isUserCreated"] &&
          parseInt(item["remainingAmount"]) > 0 &&
          (this.selectedFirm
            ? item["firm"] === this.selectedFirm[".key"]
            : true)
      );
      this.securityDeposit.amount = 0;
      this.securityDeposit.invoices.map((inv, index) => {
        this.securityDeposit.amount += Number.parseFloat(inv.amount);
        this.securityDeposit.invoices[index]["checked"] = false;
        this.securityDeposit.invoices[index]["amount"] = inv.remainingAmount;
        this.securityDeposit.invoices[index]["staticAmount"] =
          inv.remainingAmount;
      });
    },
    updateInvoice(invoiceData) {
      console.info(invoiceData);
      const updated_at = new Date().getTime();
      try {
        invoiceData["items"].forEach((item, index) => {
          item["date"] = invoiceData["date"];
          if (item.id) {
            item["updated_at"] = updated_at;
            this.$root.$firebaseRefs.item.child(item["id"]).update(item, () => {
              console.info("item udpated...");
            });
          } else {
            const response = this.$root.$firebaseRefs.item.push(item, () => {
              console.info("item pushed...");
            });
            invoiceData["items"][index]["id"] = response["key"];
          }
        });
        invoiceData["updated_at"] = updated_at;
        let key = invoiceData[".key"];
        delete invoiceData[".key"];

        this.$root.$firebaseRefs.invoice.child(key).update(invoiceData, () => {
          console.info("invoice updated...");
          this.updateInvoiceDialog = false;
        });
        invoiceData["parentInvoiceKey"] = key;
        delete invoiceData["newlyCreated"];
        this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
      } catch (e) {
        console.info("Error at update Invoice", e);
      }
    },
    managePayments() {
      switch (this.paymentType) {
        case "Cash": {
          if (this.amountFromCash) {
            let firm = this.selectedFirm;
            if (firm) {
              firm.amount = this.isBuyer
                ? Number.parseFloat(firm.amount) +
                  Number.parseFloat(this.amountFromCash)
                : Number.parseFloat(firm.amount) -
                  Number.parseFloat(this.amountFromCash);
              if (firm.amount < 0) {
                this.insufficientError = "Insufficient balance.";
                setTimeout(() => {
                  this.insufficientError = null;
                }, 3000);
              } else {
                let key = firm[".key"];
                delete firm[".key"];
                this.$root.$firebaseRefs.firm.child(key).set(firm);
              }
            }
          }
          break;
        }
        case "Bank Account": {
          if (this.amountFromBank) {
            let bank = JSON.parse(JSON.stringify(this.selectedBank));
            if (bank) {
              bank.amount = this.isBuyer
                ? Number.parseFloat(bank.amount) +
                  Number.parseFloat(this.amountFromBank)
                : Number.parseFloat(bank.amount) -
                  Number.parseFloat(this.amountFromBank);
              if (bank.amount < 0) {
                this.insufficientError = "Insufficient balance.";
                setTimeout(() => {
                  this.insufficientError = null;
                }, 3000);
              } else {
                let key = bank[".key"];
                delete bank[".key"];
                this.$root.$firebaseRefs.account.child(key).set(bank);
              }
            }
          }
          break;
        }
        case "CashAndBank Account": {
          if (this.amountFromCash && this.amountFromBank) {
            let bank = JSON.parse(JSON.stringify(this.selectedBank));
            if (bank) {
              bank.amount = this.isBuyer
                ? Number.parseFloat(bank.amount) +
                  Number.parseFloat(this.amountFromBank)
                : Number.parseFloat(bank.amount) -
                  Number.parseFloat(this.amountFromBank);
              if (bank.amount < 0) {
                this.insufficientError = "Insufficient balance.";
                setTimeout(() => {
                  this.insufficientError = null;
                }, 3000);
              } else {
                let key = bank[".key"];
                delete bank[".key"];
                this.$root.$firebaseRefs.account.child(key).set(bank);
              }
            }
            let firm = this.selectedFirm;
            if (firm) {
              firm.amount = this.isBuyer
                ? Number.parseFloat(firm.amount) +
                  Number.parseFloat(this.amountFromCash)
                : Number.parseFloat(firm.amount) -
                  Number.parseFloat(this.amountFromCash);
              if (firm.amount < 0) {
                this.insufficientError = "Insufficient balance.";
                setTimeout(() => {
                  this.insufficientError = null;
                }, 3000);
              } else {
                let key = firm[".key"];
                delete firm[".key"];
                this.$root.$firebaseRefs.firm.child(key).set(firm);
              }
            }
          }
          break;
        }
      }
    },
    getCurrentUserDetails() {
      let buyer = this.buyerById[this.$route.params.customerId];
      let seller = this.sellerById[this.$route.params.customerId];
      this.currentUser = !!buyer ? buyer : seller;
      this.isBuyer = !!buyer ? true : false;
    },
    settleDeposites() {
      this.advanceDeposit.invoices.map((invoice, index) => {
        if (invoice.checked) {
          this.$root.$firebaseRefs.customerDeposit
            .child(this.advanceDeposit.invoices[index][".key"])
            .update({
              remainingAmount:
                this.advanceDeposit.invoices[index]["remainingAmount"] -
                this.advanceDeposit.invoices[index]["amount"],
            });
          this.advanceDeposit.invoices[index]["settledAmount"] =
            invoice["amount"];
          this.advanceDeposit.invoices[index]["amount"] = 0;
          this.advanceDeposit.invoices[index]["remainingAmount"] = 0;
          this.advanceDeposit.invoices[index]["isUserCreated"] = false;
          this.advanceDeposit.invoices[index]["date"] = new Date(
            this.selectedDate
          ).getTime();
          delete this.advanceDeposit.invoices[index][".key"];
          this.$root.$firebaseRefs.customerDeposit.push(
            this.advanceDeposit.invoices[index]
          );
        }
      });
      this.securityDeposit.invoices.map((invoice, index) => {
        if (invoice.checked) {
          this.$root.$firebaseRefs.customerDeposit
            .child(this.securityDeposit.invoices[index][".key"])
            .update({
              remainingAmount:
                this.securityDeposit.invoices[index]["remainingAmount"] -
                this.securityDeposit.invoices[index]["amount"],
            });
          this.securityDeposit.invoices[index]["settledAmount"] =
            invoice["amount"];
          this.securityDeposit.invoices[index]["amount"] = 0;
          this.securityDeposit.invoices[index]["remainingAmount"] = 0;
          this.securityDeposit.invoices[index]["isUserCreated"] = false;
          this.securityDeposit.invoices[index]["date"] = new Date(
            this.selectedDate
          ).getTime();
          delete this.securityDeposit.invoices[index][".key"];
          this.$root.$firebaseRefs.customerDeposit.push(
            this.securityDeposit.invoices[index]
          );
        }
      });
      this.openingBalance.invoices.map((invoice, index) => {
        if (invoice.checked) {
          this.$root.$firebaseRefs.customerDeposit
            .child(this.openingBalance.invoices[index][".key"])
            .update({
              remainingAmount:
                this.openingBalance.invoices[index]["remainingAmount"] -
                this.openingBalance.invoices[index]["amount"],
            });
          this.openingBalance.invoices[index]["settledAmount"] =
            invoice["amount"];
          this.openingBalance.invoices[index]["amount"] = 0;
          this.openingBalance.invoices[index]["remainingAmount"] = 0;
          this.openingBalance.invoices[index]["isUserCreated"] = false;
          this.openingBalance.invoices[index]["date"] = new Date(
            this.selectedDate
          ).getTime();
          delete this.openingBalance.invoices[index][".key"];
          this.$root.$firebaseRefs.customerDeposit.push(
            this.openingBalance.invoices[index]
          );
        }
      });
      setTimeout(() => {
        this.$router.push({ path: `/buyers/${this.$route.params.customerId}` });
      }, 1500);
    },
  },
  watch: {
    selectedFirm: {
      handler(newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
    paymentType: {
      handler(newVal, oldVal) {
        switch (this.paymentType) {
          case "Cash": {
            this.amountFromCash = this.payoffAmount;
            this.amountFromBank = 0;
            break;
          }
          case "Bank Account": {
            this.amountFromCash = 0;
            this.amountFromBank = this.payoffAmount;
            break;
          }
          case "CashAndBank Account": {
            this.amountFromCash = Number.parseFloat(this.payoffAmount) / 2;
            this.amountFromBank = Number.parseFloat(this.payoffAmount) / 2;
          }
        }
      },
      deep: true,
    },
  },
};
</script>
<style >
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}

.disabledCard {
  background: lightgray;
}

.ist-datepicker .v-icon,
.ist-datepicker .v-label,
.ist-datepicker input {
  color: white !important;
}

.ist-datepicker .v-input__slot:before {
  border-color: white !important;
}

.remaing-head {
  padding: 6px;
  margin-bottom: 10px;
  color: white;
  background: #324960;
}

.remaing-head label.v-label {
  color: white;
}

.remaing-head i.v-icon {
  color: white;
}

.remaing-head input {
  color: white !important;
  font-weight: bold;
}

.fl-table {
  border-radius: 5px;
  font-size: 12px;
  font-weight: normal;
  border: none;
  border-collapse: collapse;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  background-color: white;
}

.fl-table td,
.fl-table th {
  text-align: center;
  padding: 8px;
}

.fl-table td {
  border: 1px solid #000000;
  font-size: 12px;
}

.fl-table thead th {
  color: #ffffff;
  background: #324960;
  border: 1px solid black;
}

.fl-table tr:nth-child(even) {
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/components/Buyers/RemainingBalance/RemainingBalance.vue